import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSurfaceDetectionAutomatisch = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20.885,3.33C21.004,3.599 21.214,3.818 21.482,3.937L22.617,4.445C22.956,4.604 22.956,5.082 22.617,5.242L21.492,5.75C21.223,5.869 21.004,6.089 20.895,6.357L20.009,8.438C19.85,8.767 19.372,8.767 19.212,8.438L18.326,6.357C18.207,6.088 17.997,5.869 17.729,5.75L16.604,5.242C16.265,5.083 16.265,4.605 16.604,4.445L17.729,3.937C17.998,3.818 18.217,3.598 18.326,3.33L19.212,1.249C19.371,0.92 19.849,0.92 20.009,1.249L20.885,3.33Z",
			style: { fill: "currentColor" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.135,9.305C23.135,9.833 22.717,10.271 22.209,10.271C21.701,10.271 21.283,9.843 21.283,9.305C21.283,8.767 21.701,8.339 22.209,8.339C22.717,8.339 23.135,8.767 23.135,9.305Z",
			style: { fill: "currentColor" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.09,2.922C15.608,2.922 16.016,2.494 16.016,1.956C16.016,1.418 15.608,1 15.09,1C14.572,1 14.164,1.428 14.164,1.966C14.164,2.504 14.582,2.932 15.09,2.932L15.09,2.922Z",
			style: { fill: "currentColor" }
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(1,0,0,1,-1.010552,0.95639)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M12,3L12,21",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(1,0,0,1,-1.010552,0.95639)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M3,12L21,12",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(1,0,0,1,-1.010552,0.95639)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M21,9.674L21,19C21,20.104 20.104,21 19,21L5,21C3.896,21 3,20.104 3,19L3,5C3,3.896 3.896,3 5,3L14.453,3",
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			})
		})
	] })
});
export default SvgSurfaceDetectionAutomatisch;
